export const GET_NOVA_RESEARCH_DOCUMENT_STARTED = 'GET_NOVA_RESEARCH_DOCUMENT_STARTED'
export const GET_NOVA_RESEARCH_DOCUMENT_SUCCESS = 'GET_NOVA_RESEARCH_DOCUMENT_SUCCESS'
export const GET_NOVA_RESEARCH_DOCUMENT_FAILURE = 'GET_NOVA_RESEARCH_DOCUMENT_FAILURE'
